import { useState, useEffect, useCallback } from "react";
import { api } from "../utils/api";
export const useGetOperationsPerformanceData = () => {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const fetchOperations = useCallback(async () => {
        try {
            setLoading(true);
            const res = await api.getOperationsPerformance();
            setData(res.data);
            setError(null);
        } catch (err) {
            setError(err);
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        fetchOperations();
    }, [fetchOperations]);

    return { data, loading, error, refetch: fetchOperations };
};

export const useGetSalesPerformanceData = () => {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const fetchSales = useCallback(async () => {
        try {
            setLoading(true);
            const res = await api.getSalesPerformanceForAdminDashboard();
            setData(res.data);
            setError(null);
        } catch (err) {
            setError(err);
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        fetchSales();
    }, [fetchSales]);

    return { data, loading, error, refetch: fetchSales };
};

export const useGetRequestsPendingClosure = () => {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const fetchPendingClosure = useCallback(async () => {
        try {
            setLoading(true);
            const res = await api.getRequestsPendingClosure();
            setData(res.data);
            setError(null);
        } catch (err) {
            setError(err);
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        fetchPendingClosure();
    }, [fetchPendingClosure]);

    return { data, loading, error, refetch: fetchPendingClosure };
};

export const useGetAllUsersData = () => {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        (async () => {
            try {
                setLoading(true);
                const res = await api.getAllUsers();
                setData(res.data);
                setError(null);
            } catch (err) {
                setLoading(false);
                setError(err);
            } finally {
                setLoading(false);
            }
        })();
    }, []);

    return { data, loading, error };
};

export const useGetAllInvoicesData = () => {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        (async () => {
            try {
                setLoading(true);
                const res = await api.getAllInvoices();
                setData(res.data);
                setError(null);
            } catch (err) {
                setLoading(false);
                setError(err);
            } finally {
                setLoading(false);
            }
        })();
    }, []);

    return { data, loading, error };
};

export const useGetAllPaymentsData = () => {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        (async () => {
            try {
                setLoading(true);
                const res = await api.getPayments();
                setData(res.data);
                setError(null);
            } catch (err) {
                setLoading(false);
                setError(err);
            } finally {
                setLoading(false);
            }
        })();
    }, []);

    return { data, loading, error };
};

export const useGetAllIncentivesData = () => {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const fetchIncentives = useCallback(async () => {
        try {
            setLoading(true);
            const res = await api.getIncentives();
            setData(res.data);
            setError(null);
        } catch (err) {
            setError(err);
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        fetchIncentives();
    }, [fetchIncentives]);

    return {
        data,
        loading,
        error,
        refetch: fetchIncentives, // 👈 expose this
    };
};
